// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyALp48tlkUxGv-eZYFgjrnaJz2_2g0Bbwc",
  authDomain: "club-admin-ca990.firebaseapp.com",
  projectId: "club-admin-ca990",
  storageBucket: "club-admin-ca990.firebasestorage.app",
  messagingSenderId: "592610686398",
  appId: "1:592610686398:web:96673c35a33e089629b5ef",
  measurementId: "G-6PX6GDYD8C"
};

// Initialize Firebase
let app;
let analytics;
let db;

try {
  app = initializeApp(firebaseConfig);
  
  // Analytics는 브라우저 환경에서만 초기화
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
  
  // Firestore 초기화
  db = getFirestore(app);
} catch (error) {
  console.error('Firebase 초기화 오류:', error);
}

export { app, analytics, db };

